__webpack_require__.p = "/collabora/";